import { SourcingStatus } from 'api-clients/monolith';
import clsx from 'clsx';
import _startCase from 'lodash/startCase';

import { Skeleton } from '@/components/ui/skeleton';
import { Tooltip } from '@/components/ui/tooltip';
import { Typography } from '@/components/ui/typography';

import { useSourcingStatus } from './use-sourcing-status';

interface SourcingStatusPillProps {
  status: SourcingStatus;
}

export function SourcingStatusPill({ status }: SourcingStatusPillProps) {
  const { bgColor, tooltip } = useSourcingStatus(status);

  if (!status) return null;

  return (
    <Tooltip content={tooltip}>
      <div
        className={clsx(
          'flex h-6 w-fit items-center justify-center rounded px-2',
          bgColor,
        )}
      >
        <Typography variant="small1" className="!text-fx-neutral-600">
          {_startCase(status)}
        </Typography>
      </div>
    </Tooltip>
  );
}

SourcingStatusPill.Skeleton = function StatusPillSkeleton() {
  return <Skeleton className="w-18 h-6 !rounded" />;
};
